"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.noCredits.message': '您的积分不足，无法使用聊天服务。请购买更多积分以继续使用。',
};
